export enum EWatchRoutes {
  WATCH = 'Watch'
}
